var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',[_c('i-col',{attrs:{"span":"24"}},_vm._l((_vm.detail),function(item,i){return _c(item.key,{key:i,tag:"component",staticClass:"m-t-10",attrs:{"value":item.value}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }